module.exports = __webpack_public_path__ + "img/reward14.0df167c5.png";